module.exports = __webpack_public_path__ + "static/media/sample.9468f50e.vec";